import {appContext} from '../app.context';

export class CheckBrowserPluginsService {

  static $inject: string[] = ['$window'];

  constructor(
    private $window: any
  ) {
  }

  hasPDFReaderInstalled() {
    let userBrowser = appContext.userBrowser;
    let plugins = this.$window.navigator.plugins;

    console.log(userBrowser, plugins);
    let pluginNameToCheck = '';

    if (userBrowser.isChrome) {
      pluginNameToCheck = 'Chrome PDF Viewer';
    } else {
      pluginNameToCheck = 'Adobe Acrobat';
    }

    for (let i = 0; i < plugins.length; i++) {
      if (plugins[i].name.indexOf(pluginNameToCheck) > -1) {
        return true;
      }
    }

    if (userBrowser.isIE) {

      return this.getActiveXObject('AcroPDF.PDF') || this.getActiveXObject('PDF.PdfCtrl');
    }

    return false;
  }

  getActiveXObject(name: any) {
    try {
      let acrobat = new ActiveXObject(name);

      if (acrobat) {
        return true;
      }
    } catch (e) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/services/check-browser-plugins.service.ts